import { room,hideSideMenu,Video,timerComponent,userPreferences, socket, kinoParticipants, permissions } from "../libs/roomnew";
import Timer from "./Timer";
import moment from 'moment';
import StringTest from "../components/stringTest";
import sanitizeHtml from 'sanitize-html';
import kinoTooltip from "./kinoTooltip";
export default class KinoTimer{
    constructor(){
        this.modal = null;
        this.errorMessage = null;
        this.activeTimers = {};
        this.activeTimersID = null;
        this.lastTimerSeconds = null;
        this.enabled=true;
        this.btnLabel="Kino Timer";
        this.featureName="Kino Timer";
        this.timerIcon='<i class="fas fa-stopwatch"></i>';
        this.timersContainer=null;
        this.myTimer=null;
        this.timerWidgetContainer = null;
        this.timerWidgetRight = null;
        this.showNotificationCountDownAt = 10;
        this.showCountDown = true;
        this.playCountDownSound = true;
        this.animationTimeout = null;
        this.defaultStateMinutes = null;
        this.defaultStateSeconds = null;
        this.showCountDownDefault = true;
        this.playCountDownSoundDefault = true;
        this.showNotificationCountDownAtDefault;
        this.stopTimeout = null;

        //buttons
        this.btn=null;
        this.playPauseButton = null;
        this.stopButton = null;

        //states
        this.isPaused       = true;
        this.isStopped      = true;

        //icons
        this.pauseIcon      = `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50"><g transform="translate(-132 -746)"><g transform="translate(132 746)" fill="none"><path d="M25,0A25,25,0,1,1,0,25,25,25,0,0,1,25,0Z" stroke="none"/><path d="M 25 3 C 22.02869987487793 3 19.14785957336426 3.581260681152344 16.43753051757812 4.727638244628906 C 13.81813812255859 5.835540771484375 11.46506118774414 7.4222412109375 9.443649291992188 9.443649291992188 C 7.4222412109375 11.46506118774414 5.835540771484375 13.81813812255859 4.727638244628906 16.43753051757812 C 3.581260681152344 19.14785957336426 3 22.02869987487793 3 25 C 3 27.97130012512207 3.581260681152344 30.85214042663574 4.727638244628906 33.56246948242188 C 5.835540771484375 36.18186187744141 7.4222412109375 38.53493881225586 9.443649291992188 40.55635070800781 C 11.46506118774414 42.5777587890625 13.81813812255859 44.16445922851562 16.43753051757812 45.27236175537109 C 19.14785957336426 46.41873931884766 22.02869987487793 47 25 47 C 27.97130012512207 47 30.85214042663574 46.41873931884766 33.56246948242188 45.27236175537109 C 36.18186187744141 44.16445922851562 38.53493881225586 42.5777587890625 40.55635070800781 40.55635070800781 C 42.5777587890625 38.53493881225586 44.16445922851562 36.18186187744141 45.27236175537109 33.56246948242188 C 46.41873931884766 30.85214042663574 47 27.97130012512207 47 25 C 47 22.02869987487793 46.41873931884766 19.14785957336426 45.27236175537109 16.43753051757812 C 44.16445922851562 13.81813812255859 42.5777587890625 11.46506118774414 40.55635070800781 9.443649291992188 C 38.53493881225586 7.4222412109375 36.18186187744141 5.835540771484375 33.56246948242188 4.727638244628906 C 30.85214042663574 3.581260681152344 27.97130012512207 3 25 3 M 25 0 C 38.80712127685547 0 50 11.19287872314453 50 25 C 50 38.80712127685547 38.80712127685547 50 25 50 C 11.19287872314453 50 0 38.80712127685547 0 25 C 0 11.19287872314453 11.19287872314453 0 25 0 Z" stroke="none" fill="#e0e4e5"/></g><rect width="9" height="22" rx="2" transform="translate(146 760)" fill="#e0e4e5"/><rect width="9" height="22" rx="2" transform="translate(159 760)" fill="#e0e4e5"/></g></svg>`;
        this.resumeIcon     = `<svg style="fill: none !important" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"> <g clip-path="url(#clip0_2034_337)"> <path d="M7.99833 0.799874C6.28207 0.800456 4.62245 1.41409 3.31864 2.53017C2.01484 3.64625 1.15259 5.19137 0.88732 6.88701C0.622049 8.58264 0.971207 10.3173 1.87186 11.7782C2.77251 13.2392 4.16541 14.3304 5.7995 14.8551C7.43356 15.3798 9.20134 15.3036 10.7842 14.6401C12.367 13.9766 13.6608 12.7695 14.4323 11.2365C15.2038 9.70339 15.4023 7.94512 14.992 6.27862C14.5817 4.61214 13.5896 3.147 12.1946 2.14733C10.9739 1.26505 9.50448 0.793216 7.99833 0.799874Z" stroke="#F89F37"/> <path d="M11.179 7.13359C11.8457 7.51849 11.8457 8.48074 11.179 8.86564L7.16016 11.1859C6.49349 11.5708 5.66016 11.0897 5.66016 10.3199V5.67932C5.66016 4.90952 6.49349 4.42839 7.16016 4.81329L11.179 7.13359Z" fill="#F89F37"/> </g> <defs> <clipPath id="clip0_2034_337"> <rect width="16" height="16" fill="white"/> </clipPath> </defs> </svg>`;
        this.stopIcon       = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 1000 1000" enable-background="new 0 0 1000 1000" xml:space="preserve"><path d="M500,10C229.4,10,10,229.4,10,500s219.4,490,490,490s490-219.4,490-490S770.6,10,500,10z M500,928.7C263.6,928.7,71.3,736.4,71.3,500C71.3,263.6,263.6,71.3,500,71.3c236.4,0,428.7,192.3,428.7,428.7C928.7,736.4,736.4,928.7,500,928.7z"/><path d="M622.5,316.2h-245c-33.8,0-61.2,27.4-61.2,61.2v245c0,33.8,27.4,61.3,61.2,61.3h245c33.8,0,61.3-27.4,61.3-61.3v-245C683.7,343.7,656.3,316.2,622.5,316.2z"/></svg>`;

        this.stringTest = new StringTest()
        this.kinoToolTip = new kinoTooltip();
        this.modalInit = false;
        this.preferences = {};
    };

    events(){
        let t=this;
        userPreferences.registerFeatureHandler('kino_timer',(preferences)=>{
            if(!permissions.hasKinoTimer()){return}
            // console.log(`Received kino timer preferences ${typeof preferences}`,preferences);
            if(typeof preferences == 'object' && Object.keys(preferences).length > 0){
                t.preferences=preferences;
                t.onPreferencesLoaded();
            }
        });
    };

    addOptionButton() {
        var t = this;
        t.enabled = permissions.hasKinoTimer();
        if(!t.enabled && !permissions.isWorkspace){
            return
        }

        t.optionIcon = $('<div/>', {
            class: "option-icon",
            id: "vbgIcon",
            html: t.timerIcon,
        });
        t.optionName = $('<div/>', {
            class: "option-name",
            id: "option-name-vbg",
            html: t.btnLabel,
        });
        t.optionAction = $('<div/>', {
            class: "option-action",
            id: "option-action-vbg",
            html: '',
        });
        t.optionDescription = $('<div/>', {
            class: "option-description",
            html: [ t.optionName, t.optionAction],
        });
        t.optionsBtn = $('<div/>', {
            class: `option ${!t.enabled ? 'feature-disabled' :''}`,
            id: 'kinoTimerOptionsBtn',
            html: [t.optionIcon, t.optionDescription],
        }).on('click',()=>{
            if(!t.enabled){return}
            //this.startNewTimer();
            t.renderModal();
        });
        if(!t.enabled){
            t.optionsBtn.attr('data-toggle','tooltip')
            t.optionsBtn.attr('data-placement','top')
            t.optionsBtn.attr('data-original-title','This feature is disabled in this workspace.')
        }
        $("#option-list").find("#kinoTimerOptionsBtn").remove();
        $("#option-list").append(t.optionsBtn);
    };

    removeOptionButton(){
        var t=this;
        t.enabled=false;
        if(t.btn !== null){
            t.btn.remove();
        }
        t.btn=null;
        $("#option-list").find("#kinoTimerOptionsBtn").remove();
    };

    createTimersContainer(){
        let t=this;
        if(!t.timersContainer){
            t.timersContainer=$("<div/>",{
                class:`timer-timers-container ${permissions.hasKinoTimer() ? "border-class" : ""} d-none`
            });
            $(".strip-options-content").append(t.timersContainer);
        }
    };

    isModerator(){
        return HOST == 1 || ROLE == "moderator";
    }
    appendTimerWidget(timer_id, title, seconds_left){
        let t = this;
        let time = null;
        if (t.lastTimerSeconds){
            time = t.secondsToTime(t.lastTimerSeconds);
        }
        if(seconds_left){
            time = t.secondsToTime(seconds_left);
        }
        // this.activeTimers[timer_id].hoursSpan=$("<span/>",{
        //     class:"timer-widget-timeleft-span",
        //     id:'widget-hours-span',
        //     value:'00',
        //     html: '00'
        // });
        t.activeTimers.minutesSpan=$("<span/>",{
            class:"timer-widget-timeleft-span",
            id:'widget-minutes-span',
            value:  time ? `${time.m}` : '00',
            html:   time ? `${time.m}` : '00'
        });
        t.activeTimers.secondsSpan=$("<span/>",{
            class:"timer-widget-timeleft-span",
            id:'widget-seconds-span',
            value:  time ? `${time.s}` : '00',
            html:   time ? `${time.s}` : '00',
        });
        let hourDivider=$("<span/>",{
            class:"timer-widget-separator",
            html:":"
        });
        let minuteDivider=$("<span/>",{
            class:"timer-widget-separator",
            html:":"
        });
        let timerClockContainer=$("<div/>",{
            class:"timer-widget-clock",
            html:[
            // t.activeTimers[timer_id].hoursSpan,
            // hourDivider,
            t.activeTimers.minutesSpan,
            minuteDivider,
            t.activeTimers.secondsSpan]
        });
        t.timerWidgetLeft = $('<div/>',{
            class: `timer-widget-left ${!permissions.hasKinoTimer() ? "cursor-default" : ""} `,
            html: [timerClockContainer]
        }).on('click', () => {
            let t = this;
            if(!permissions.hasKinoTimer()) {return}
            let timeout;
            t.timerWidgetLeft.addClass('button-disabled')
            t.renderModal();
            timeout = setTimeout(()=>{
                t.timerWidgetLeft.removeClass('button-disabled');
                clearTimeout(timeout);
            },2000)

        });
        t.timerWidgetMiddle = $('<div/>',{
            html: ''
        });

        t.removeTimer=$("<span/>", {
        class:`remove-timer-btn ${!permissions.hasKinoTimer() && "d-none"}`,
        html:`<svg class="remove-option-icon" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink" width="512" height="512" x="0" y="0" viewBox="0 0 45.334 45.334" style="enable-background:new 0 0 512 512" xml:space="preserve" class=""><g><path d="M43.576 35.092 31.152 22.668l12.424-12.424a6 6 0 0 0-8.485-8.485L22.666 14.183 10.242 1.758a6 6 0 0 0-8.485 8.485l12.425 12.424L1.757 35.091a6 6 0 1 0 8.486 8.485l12.423-12.423 12.425 12.424c1.173 1.171 2.707 1.757 4.243 1.757s3.071-.586 4.243-1.757a6 6 0 0 0-.001-8.485z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></svg>`
        }).on("click", function(){
            t.closeAndStopTimer()
        })


        t.timerWidgetContainer = $('<div/>',{
            class: 'timer-widget-container',
            html: [t.timerWidgetMiddle, t.timerWidgetLeft,t.removeTimer]
        })
        if(permissions.hasKinoTimer()){
            t.addModeratorRights();
        }
        $(".timer-timers-container").removeClass('d-none');
        $(".timer-timers-container").html(t.timerWidgetContainer);
        // t.timerWidgetContainer.appendTo(".timer-timers-container");

    };

    addModeratorRights(){
        let t = this;
        if(!permissions.hasKinoTimer()){return}
        if(t.timerWidgetLeft && t.timerWidgetLeft.hasClass('cursor-default')){
            t.timerWidgetLeft.removeClass('cursor-default');
        }
        // console.log('called moderator rights')
        t.playPauseButton = $('<button/>',{
            id: 'play-pause-kino-timer',
            class: 'timer-buttons',
            'data-toggle': "tooltip",
            'data-placement': "top",
            title: t.isPaused ?  t.isStopped ? "Play" : "Resume" : "Pause",
            html: t.isPaused ? t.resumeIcon : t.pauseIcon,
        }).on('click', () => {
            t.pauseResumeRestart();
            $(t.playPauseButton).attr('disabled', true).addClass('disabled');
            setTimeout(()=>{
                $(t.playPauseButton).removeAttr('disabled').removeClass('disabled');
            },1100)
        });
        t.stopButton = $('<button/>',{
            id: 'stop-kino-timer',
            class: `timer-buttons ${t.isStopped ? "disabled cursor-default" : ""}`,
            'data-toggle': "tooltip",
            'data-placement': "top",
            title: "Stop",
            html: t.stopIcon,
        }).on('click', () => {
            t.stopTimer();
            if(t.isStopped){
                $(t.stopButton).attr('disabled', true).addClass('disabled cursor-default');
            }
        });
        t.closeTimerSection = $('<span/>',{
            id: 'close-timer-widget',
            class: 'timer-buttons',
            'data-toggle': 'tooltip',
            'data-placement': 'top',
            title: '',
            html: '<i class="icofont-close icofont-1x"></i>',
        }).on('click', ()=>{
            t.closeTimer();
        }).on('mouseover', function(){
            if(!t.isStopped){
                $(this).attr({'data-original-title': 'An active timer is detected'});
            }else{
                $(this).attr({'data-original-title': ''});
            }
        });
        let timerControls = $('<div/>',{
            class: 'timer-controls',
            html: [t.stopButton,t.playPauseButton]
        });
        t.timerWidgetRight = $('<div/>',{
            class: 'timer-widget-right',
            html: timerControls
        });
        // t.timerWidgetContainer.append(t.timerWidgetRight);
        t.timerWidgetRight.appendTo(t.timerWidgetContainer);
    }

    addRoundsContainer(actual, total){
        // let t = this;
        // t.removeRoundsContainer();

        // t.actualRound = $('<span/>',{
        //     html: actual
        // })
        // t.totalRounds = $('<span/>',{
        //     html: total
        // })
        // t.roundsContainer = $('<div/>',{
        //     class: 'rounds-container',
        //     html: [t.actualRound, '/', t.totalRounds]
        // })
        // t.timerWidgetRoundsTitle = $('<span/>',{
        //     class: 'rounds-title',
        //     html: 'ROUNDS'
        // })
        // t.timerWidgetRounds = $('<div/>',{
        //     class: 'timer-widget-center',
        //     html: [t.timerWidgetRoundsTitle, t.roundsContainer]
        // })

        // // t.timerWidgetMiddle.append(t.timerWidgetRounds);
        // t.timerWidgetRounds.appendTo(t.timerWidgetMiddle);
    }

    removeRoundsContainer(){
        let t = this;
        if(t.timerWidgetRounds){
            t.timerWidgetRounds.remove();
        }
    }

    removeModeratorRights(){
        let t = this;
        if(t.timerWidgetLeft){
            t.timerWidgetLeft.addClass('cursor-default');
        }
        if(t.timerWidgetRight){
            t.timerWidgetRight.remove();
        }
        if(t.modal){
            t.hideModal();
        }
        // if(t.timerWidgetContainer && t.isStopped){
        //     $(".timer-timers-container").addClass('d-none');
        //     t.timerWidgetContainer.remove();
        // }

    }

    updateSecondsLeft(timer_id,seconds){
        let t = this;
        try {
            let converted=t.secondsToTime(seconds);
            // let minute=converted.m < 10 ? '0'+converted.m : converted.m;
            // let second=converted.s < 10 ? '0'+converted.s : converted.s;
            t.activeTimers.minutesSpan.html(converted.m);
            t.activeTimers.secondsSpan.html(converted.s);

        } catch (error) { console.error("[Kino Error] [KinoTimer]", error); }
    };

    secondsToTime(secs){
        secs = Math.round(secs);
        var hours = Math.floor(secs / (60 * 60));
        if(hours < 10){hours = "0" + parseInt(hours);}

        var divisor_for_minutes = secs % (60 * 60);
        var minutes = Math.floor(divisor_for_minutes / 60);
        if(minutes < 10){minutes = "0" + parseInt(minutes);}

        var divisor_for_seconds = divisor_for_minutes % 60;
        var seconds = Math.ceil(divisor_for_seconds);
        if(seconds < 10){seconds = "0" + parseInt(seconds);}

        var obj = {
            "h": hours,
            "m": minutes,
            "s": seconds
        };
        return obj;
    }

    renderModal(){
        let t=this;
        hideSideMenu();
        if(t.modal && t.modal.hasClass('minimized-modal')){
            Video.minimizedContent.maximizeModal('kinoTimerModal');
            return;
        }
        let timerLength = null;
        if(t.lastTimerSeconds){
            timerLength = t.secondsToTime(t.lastTimerSeconds);
        }
        if(t.modal){t.modal.remove()}
        if(!permissions.hasKinoTimer()){return}
        //hours
        let hourAddButton=$("<div/>",{
            class:'timer-hour-add-button',
            html:`<i class="fas fa-2x fa-angle-up"></i>`
        }).on('click',()=>{
            let input=parseInt(t.hourInput.val());
            if(isNaN(input)){
                return
            }
            input++
            if(input > 1 || input < 0){
                return
            }
            t.hourInput.val('0'+input)
        });
        let hourSubtractButton=$("<div/>",{
            class:'timer-hour-subtract-button',
            html:`<i class="fas fa-2x fa-angle-down"></i>`
        }).on('click',()=>{
            let input=parseInt(t.hourInput.val());
            if(isNaN(input)){
                return
            }
            input--
            if(input > 1 || input < 0){
                return
            }
            t.hourInput.val('0'+input)
        });

        // let timerDurationTitle = $('<div/>',{
        //     class: 'd-flex h5 justify-content-center m-0"',
        //     html: 'Timer duration'
        // });

        let timerCountdownTitle = $('<div/>',{
            class: 'd-flex h6 mb-0 pt-3 mb-2 fit-content ignore-drag',
            html: 'Options'
        });

        t.hourInput=$('<input/>',{
            class:'timer-hour-input form-control',
            value:'00',
            type:'number',
            min:0,
            max:1
        }).on('keydown keyup paste change',function(){
            t.errorMessage.html('').removeClass('visible');
            let input=parseInt($(this).val());
            if(isNaN(input)){
                $(this).val('00');
            }
            if(input < 0){
                $(this).val('00');
            }else if(input > 1){
                $(this).val('01');
            }else if(input > 0 && input<=9){
                $(this).val('0'+input);
            }
        });
        let hourInputContainer=$("<div/>",{
            class:'timer-hour-input-container ignore-drag',
            html:[
                hourAddButton,
                t.hourInput,
                hourSubtractButton
            ]
        });
        //minutes
        let minuteAddButton=$("<div/>",{
            class:'timer-hour-add-button',
            html:`<i class="fas fa-2x fa-angle-up"></i>`
        }).on('click',()=>{
            let input=parseInt(t.minuteInput.val());
            if(isNaN(input)){
                return
            }
            input++
            if(input > 59 || input < 0){
                return
            }
            if(input > 0 && input<=9){
                t.minuteInput.val('0'+input);
                t.defaultStateMinutes = '0'+input;
            }else{
                t.minuteInput.val(input);
                t.defaultStateMinutes = input;
            }
        });
        let minuteSubtractButton=$("<div/>",{
            class:'timer-hour-subtract-button',
            html:`<i class="fas fa-2x fa-angle-down"></i>`
        }).on('click',()=>{
            let input=parseInt(t.minuteInput.val());
            if(isNaN(input)){
                return
            }
            input--
            if(input > 59 || input < 0){
                return
            }
            if(input >= 0 && input <= 9){
                t.minuteInput.val('0'+input);
                t.defaultStateMinutes = '0'+input;
            }else{
                t.minuteInput.val(input);
                t.defaultStateMinutes = input;
            }
        });
        t.minuteInput=$('<input/>',{
            class:'timer-hour-input form-control',
            // type:'number',
            type: 'text',
            maxlength: 2,
            // min:0,
            // max:59
            value: t.defaultStateMinutes ? t.defaultStateMinutes : '00',
        }).on('input paste change',function(e){
            $(this).val(e.currentTarget.value.replace(/[^0-9]/g, ''));
            let val = e.currentTarget.value
            let regTest = t.stringTest.timerTest(val);
            $(this).val(regTest);
            t.defaultStateMinutes = regTest;
        }).on('blur', function(e){
            // console.log(e.currentTarget.value)
            if(e.currentTarget.value < 10 && e.currentTarget.value != ''){
                $(this).val('0'+ parseInt(e.currentTarget.value))
                t.defaultStateMinutes = '0'+ parseInt(e.currentTarget.value)
            }
            if(e.currentTarget.value == ''){
                $(this).val('00')
                t.defaultStateMinutes = 0;
            }
        }).on('keydown', function(e){
            let value = $(this).val();
            if(value != NaN && ((e.keyCode == '38' && value < 59) || (e.keyCode == '40' && value > 0))){
                if(e.keyCode == '38' && value < 59){
                    value++
                }
                if(e.keyCode == '40' && value > 0){
                    value--
                }

                if(value < 10){
                    value = `0${value}`;
                }else{
                    parseInt(value);
                }
                $(this).val(value);
                t.defaultStateMinutes = value;
            }
            if(e.keyCode == '13'){
                t.startNewTimer();
            }
        }).trigger('input');
        let minuteInputContainer=$("<div/>",{
            class:'timer-hour-input-container ignore-drag',
            html:[
                minuteAddButton,
                t.minuteInput,
                minuteSubtractButton
            ]
        });
        //seconds
        let secondAddButton=$("<div/>",{
            class:'timer-hour-add-button',
            html:`<i class="fas fa-2x fa-angle-up"></i>`
        }).on('click',()=>{
            let input=parseInt(t.secondInput.val());
            if(isNaN(input)){
                return
            }
            input++;
            if(input > 59 || input < 0){
                return
            }
            if(input >= 0 && input <= 9){
                t.secondInput.val('0'+input);
                t.defaultStateSeconds = '0'+input;
            }else{
                t.secondInput.val(input);
                t.defaultStateSeconds = input;
            }
        });
        let secondSubtractButton=$("<div/>",{
            class:'timer-hour-subtract-button',
            html:`<i class="fas fa-2x fa-angle-down"></i>`
        }).on('click',()=>{
            let input=parseInt(t.secondInput.val());
            if(isNaN(input)){
                return
            }
            input--
            if(input > 59 || input < 0){
                return
            }
            if(input >= 0 && input<=9){
                t.secondInput.val('0'+input);
                t.defaultStateSeconds = '0'+input;
            }else{
                t.secondInput.val(input);
                t.defaultStateSeconds = input;
            }
        });
        t.secondInput=$('<input/>',{
            class:'timer-hour-input  form-control',
            type: 'text',
            maxlength: 2,
            value: t.defaultStateSeconds ? t.defaultStateSeconds : 30,
        }).on('input paste change',function(e){
            $(this).val(e.currentTarget.value.replace(/[^0-9]/g, ''));
            // let val = e.currentTarget.value
            let regTest = t.stringTest.timerTest(e.currentTarget.value);
            $(this).val(regTest);
            t.defaultStateSeconds = regTest;
        }).on('blur', function(e){
            // console.log(e.currentTarget.value)
            if(e.currentTarget.value < 10 && e.currentTarget.value != ''){
                $(this).val('0'+ parseInt(e.currentTarget.value))
                t.defaultStateSeconds = '0'+ parseInt(e.currentTarget.value);
            }
            if(e.currentTarget.value == ''){
                $(this).val('30')
                t.defaultStateSeconds = 30;
            }
        }).on('keydown', function(e){
            let value = $(this).val();
            if(value != NaN && ((e.keyCode == '38' && value < 59) || (e.keyCode == '40' && value > 0))){
                if(e.keyCode == '38' && value < 59){
                    value++
                }
                if(e.keyCode == '40' && value > 0){
                    value--
                }

                if(value < 10){
                    value = `0${value}`;
                }else{
                    parseInt(value);
                }
                $(this).val(value);
                t.defaultStateSeconds = value;
            }
            if(e.keyCode == '13'){
                t.startNewTimer();
            }
        }).trigger('input');
        let secondInputContainer=$("<div/>",{
            class:'timer-hour-input-container ignore-drag',
            html:[
                secondAddButton,
                t.secondInput,
                secondSubtractButton
            ]
        });

        let minuteseparator=$("<span/>",{
            html:":",
            class:"timer-separator"
        });
        let secondseparator=$("<span/>",{
            html:":",
            class:"timer-separator"
        });

        let pickTimeContainer=$("<div/>",{
            class:"timer-pick-time-container",
            html:[
                // hourInputContainer,
                // minuteseparator,
                minuteInputContainer,
                secondseparator,
                secondInputContainer
            ]
        });
        // timer title
        let timerDurationLabel=$('<div/>',{
            class:'timer-duration-label',
            html:[t.timerIcon,' Duration']
        });
        let timerTitleLabel=$('<div/>',{
            class:'timer-title-label',
            html:'Title'
        });
        t.timerTitleInput=$('<input/>',{
            type:'text',
            maxlength:100,
            placeholder:'Title',
            class:'timer-title-input form-control'
        }).on('keyup paste change',()=>{
            t.errorMessage.html('').removeClass('visible');
        });

        let durationContainer=$('<div/>',{
            class:'timer-duration-container',
            html:[
                // timerDurationLabel,
                // timerDurationTitle,
                pickTimeContainer
            ]
        });

        let warnMessage='';
        // if(this.activeTimers.id && !this.isStopped){
        //     warnMessage=`There is a active timer running`;
        // }
        t.errorMessage = $("<span/>", {
            class: `text-center timer-error-message error_kino ignore-drag`,
            html:warnMessage
        });
        // this.tip = $('<span/>',{
        //     class: "text-muted text-center d-flex justify-content-center",
        //     html: 'Minimum duration: 10 seconds'
        // });

        t.notificationTimeinputLabel = $('<label/>', {
            for: 'notification-time-input',
            html: 'Show a '
        })

        t.minutesOrSecCountdown = $('<span/>',{
            class: 'mr-1',
            html: 'seconds'
        })
        t.notificationTimeInputMinutes = $('<input/>',{
            type: 'text',
            maxlength: 2,
            value: t.showNotificationCountDownAtDefault == 0 ? '00' : t.showNotificationCountDownAtDefault > 0 ? t.secondsToTime(t.showNotificationCountDownAtDefault).m : '00',
        }).on('input paste change',function(e){
            $(this).val(e.currentTarget.value.replace(/[^0-9]/g, ''));
            let val = e.currentTarget.value
            let regTest = t.stringTest.timerTest(val);
            $(this).val(regTest);
            let timeToSec = t.durationToSeconds(t.notificationTimeInputMinutes.val(), t.notificationTimeInputSeconds.val())
            t.showNotificationCountDownAtDefault = timeToSec
            if(timeToSec > 59){
                t.minutesOrSecCountdown.html('minutes')
            }else{
                t.minutesOrSecCountdown.html('seconds')
            }
        }).on('blur', function(e){
            // console.log(e.currentTarget.value)
            if(e.currentTarget.value < 10 && e.currentTarget.value != ''){
                $(this).val('0'+ parseInt(e.currentTarget.value))
            }
            if(e.currentTarget.value == ''){
                $(this).val('00')
            }
            let timeToSec = t.durationToSeconds(t.notificationTimeInputMinutes.val(), t.notificationTimeInputSeconds.val())
            t.showNotificationCountDownAtDefault = timeToSec
            if(timeToSec > 59){
                t.minutesOrSecCountdown.html('minutes')
            }else{
                t.minutesOrSecCountdown.html('seconds')
            }
        }).on('keydown', function(e){
            let value = $(this).val();
            if(value != NaN && ((e.keyCode == '38' && value < 59) || (e.keyCode == '40' && value > 0))){
                if(e.keyCode == '38' && value < 59){
                    value++
                }
                if(e.keyCode == '40' && value > 0){
                    value--
                }

                if(value < 10){
                    value = `0${value}`;
                }else{
                    parseInt(value);
                }
                $(this).val(value);
                let timeToSec = t.durationToSeconds(t.notificationTimeInputMinutes.val(), t.notificationTimeInputSeconds.val())
                t.showNotificationCountDownAtDefault = timeToSec
                if(timeToSec > 59){
                    t.minutesOrSecCountdown.html('minutes')
                }else{
                    t.minutesOrSecCountdown.html('seconds')
                }
            }
        });
        t.notificationTimeInputSeconds = $('<input/>',{
            type: 'text',
            maxlength: 2,
            value: t.showNotificationCountDownAtDefault == 0 ? '00' : t.showNotificationCountDownAtDefault > 0 ? t.secondsToTime(t.showNotificationCountDownAtDefault).s : 10,
        }).on('input paste change',function(e){
            $(this).val(e.currentTarget.value.replace(/[^0-9]/g, ''));
            let val = e.currentTarget.value
            let regTest = t.stringTest.timerTest(val);
            $(this).val(regTest);
            let timeToSec = t.durationToSeconds(t.notificationTimeInputMinutes.val(), t.notificationTimeInputSeconds.val())
            t.showNotificationCountDownAtDefault = timeToSec
            if(timeToSec > 59){
                t.minutesOrSecCountdown.html('minutes')
            }else{
                t.minutesOrSecCountdown.html('seconds')
            }
        }).on('blur', function(e){
            // console.log(e.currentTarget.value)
            if(e.currentTarget.value < 10 && e.currentTarget.value != ''){
                $(this).val('0'+ parseInt(e.currentTarget.value))
            }
            if(e.currentTarget.value == ''){
                $(this).val('00')
            }
            let timeToSec = t.durationToSeconds(t.notificationTimeInputMinutes.val(), t.notificationTimeInputSeconds.val())
            t.showNotificationCountDownAtDefault = timeToSec
            if(timeToSec > 59){
                t.minutesOrSecCountdown.html('minutes')
            }else{
                t.minutesOrSecCountdown.html('seconds')
            }
        }).on('keydown', function(e){
            let value = $(this).val();
            if(value != NaN && ((e.keyCode == '38' && value < 59) || (e.keyCode == '40' && value > 0))){
                if(e.keyCode == '38' && value < 59){
                    value++
                }
                if(e.keyCode == '40' && value > 0){
                    value--
                }

                if(value < 10){
                    value = `0${value}`;
                }else{
                    parseInt(value);
                }
                $(this).val(value);
                let timeToSec = t.durationToSeconds(t.notificationTimeInputMinutes.val(), t.notificationTimeInputSeconds.val())
                t.showNotificationCountDownAtDefault = timeToSec
                if(timeToSec > 59){
                    t.minutesOrSecCountdown.html('minutes')
                }else{
                    t.minutesOrSecCountdown.html('seconds')
                }
            }
        });

        t.mSpan = $('<span/>',{
            class: 'timer-mm-ss-span',
            html:'mm'
        })
        t.sSpan = $('<span/>',{
            class: 'timer-mm-ss-span',
            html:'ss'
        })
        t.minuteWrapper = $('<div/>',{
            class: 'd-flex flex-column',
            html: [t.notificationTimeInputMinutes, t.mSpan]
        })

        t.secondWrapper = $('<div/>',{
            class: 'd-flex flex-column',
            html: [t.notificationTimeInputSeconds, t.sSpan]
        })

        t.notificationTimeInput = $('<div/>',{
            class: 'input-time',
            html: [t.minuteWrapper,':',t.secondWrapper]
        })

        let showCountdownNotificationSpan = $('<span/>',{
            class: 'kino-slider round',
        });

        let showCountdownNotificationInput = $('<input/>',{
            type: 'checkbox',
            id: 'show-countdown-notification',
            checked: t.showCountDownDefault,
        }).on('change click', function(e){
            // console.log($(this).prop('checked'))
            if($(this).prop('checked')){
                t.showCountDownDefault = true;
                clearTimeout(t.animationTimeout);
                playSoundCountdownInput.attr('disabled', false);
                // notificationTimeContainer.append(notificationTimeInputContainer);
                notificationTimeInputContainer.removeClass('hide');
            }else{
                t.showCountDownDefault = false;
                t.playCountDownSoundDefault = false;
                clearTimeout(t.animationTimeout);
                notificationTimeInputContainer.addClass('hide');
                playSoundCountdownInput.attr('disabled', true).prop('checked', false)
            }
            //timerComponent.updateTimerInputs();
        });

        let showCountdownNotificationSwitch = $('<label/>',{
            class: 'switch',
            for: 'show-countdown-notification',
            html: [showCountdownNotificationInput, showCountdownNotificationSpan]
        });

        let showCountdownNotification = $('<div/>',{
            class: 'd-flex w-100 align-items-center justify-content-between kino-toggle',
            html: ['Show time\'s up notification', showCountdownNotificationSwitch]
        });

        let showCountdownNotificationContainer = $('<div/>',{
            class: 'show-countdown-notification-container ignore-drag',
            html: [showCountdownNotification]
        });

        let notificationTimeInputContainer = $('<div/>', {
            class: `notification-kino-timer-container ${t.showCountDownDefault ? '': 'hide'} ignore-drag`,
            html: [t.notificationTimeinputLabel, t.notificationTimeInput, /*t.minutesOrSecCountdown,*/'countdown notification']
        });

        let notificationTimeContainer = $('<div/>', {
            class: 'd-flex flex-column mb-1',
            html: [timerCountdownTitle, showCountdownNotificationContainer, notificationTimeInputContainer]
        });
        //
        let playSoundCountdownSpan = $('<span/>',{
            class: 'kino-slider round',
        });

        let playSoundCountdownInput = $('<input/>',{
            type: 'checkbox',
            id: 'play-sound-countdown-notification',
            disabled: !t.showCountDownDefault,
            checked: t.playCountDownSoundDefault
        }).on('change click', function(e){
            // console.log($(this).prop('checked'))
            if(playSoundCountdownInput.prop('checked')){
                t.playCountDownSoundDefault = true;
            }else{
                t.playCountDownSoundDefault = false;
            }
            //timerComponent.updateTimerInputs();
        });

        let playSoundCountdownSwitch = $('<label/>',{
            class: 'switch',
            for: 'play-sound-countdown-notification',
            html: [playSoundCountdownInput, playSoundCountdownSpan]
        });

        let playSoundCountdownContainer = $('<div/>',{
            class: 'd-flex w-100 align-items-center justify-content-between ignore-drag kino-toggle',
            html: ['Play notification sound', playSoundCountdownSwitch]
        });

        let countdowNotificationTimeContainer = $('<div/>', {
            class: 'd-flex flex-column',
            html: [notificationTimeContainer, playSoundCountdownContainer]
        });


        let modalBody = $("<div/>", {
            class: 'modal-body mx-auto p-0',
            html: [
                durationContainer,
                // this.tip,
                countdowNotificationTimeContainer,
                t.errorMessage
            ],
            style: 'width: 90%;'
        });
        let cancelTimerBtn = $('<button/>',{
            class: "btn btn-primary kino-btn-secondary",
            type: "button",
            html: "cancel",
            'data-dismiss': "modal"
        })
        let startTimerBtn = $('<button/>', {
            class: "btn btn-primary kino-btn-primary",
            type: "button",
            html: "Set countdown"
        }).on('click', ()=>{
            t.startNewTimer();
        });
        let modalFooter = $("<div/>", {
            class: "modal-footer border-0",
            html: [cancelTimerBtn, startTimerBtn]
        });

        let minimizeModalBtn = $('<button/>',{
            class: "close-button-modal-kino minimize-button",
            type: "button",
            html: `<i class="fas fa-window-minimize"></i>`
        }).on('click', ()=>{
            Video.minimizedContent.minimizeModal('kinoTimerModal', t.timerIcon);
        });

        let closeModalBtn = $("<button/>", {
            class: "close-button-modal-kino",
            type: "button",
            html: `<svg aria-hidden="true" focusable="false" data-prefix="fal" data-icon="times" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512" class="svg-inline--fa fa-times fa-w-10"><path fill="#032836" d="M193.94 256L296.5 153.44l21.15-21.15c3.12-3.12 3.12-8.19
            0-11.31l-22.63-22.63c-3.12-3.12-8.19-3.12-11.31 0L160 222.06 36.29 98.34c-3.12-3.12-8.19-3.12-11.31 0L2.34
            120.97c-3.12 3.12-3.12 8.19 0 11.31L126.06 256 2.34 379.71c-3.12 3.12-3.12 8.19 0 11.31l22.63 22.63c3.12
            3.12 8.19 3.12 11.31 0L160 289.94 262.56 392.5l21.15 21.15c3.12 3.12 8.19 3.12 11.31 0l22.63-22.63c3.12-3.12
            3.12-8.19 0-11.31L193.94 256z"></path>
        </svg>`
        }).on('click', e => {
            t.hideModal();
        });
        // let modalSubHeader = $('<span/>',{
        //     class: 'text-center ignore-drag',
        //     html: `Set a timer countdown<br/> The countdown will be visible to all the participants in the Kino`,
        // })
        let modalHeader = $("<div/>", {
            class: "modal-header modal-header-kino",
            html: [`<h4 class="modal-title text-center ignore-drag" id="kinoTimerModalTitle">${t.featureName}</h4>`,minimizeModalBtn, closeModalBtn]
        });

        let modalContent = $("<div/>", {
            class: 'modal-content kino-enhanced-modal',
            html: [modalHeader, modalBody, modalFooter]
        });

        let modalDialog = $("<div/>", {
            class: "modal-dialog modal-dialog-centered modal-dialog-timer modal-inside-kino",
            role: "document",
            html: modalContent
        });
        t.modal = $("<div/>", {
            class: "modal modal-inside-kino fade",
            id: "kinoTimerModal",
            tabindex: "-1",
            role: "dialog",
            'aria-labelledby': "kinoTimerModal",
            'aria-hidden': "true",
            'data-backdrop': "static",
            'data-keyboard': "false",
            html: modalDialog
        }).on('hidden.bs.modal', function(){
            //here you can add any additional functionality when modal is being closed
        }).on('shown.bs.modal', function(e){
            //here you can add any additional functionality when modal is being opened
            if(t.showCountDownDefault){
                // notificationTimeContainer.append(notificationTimeInputContainer);
                notificationTimeInputContainer.removeClass('hide')
            }
        }).on('keyup',function(e){
            if (e.keyCode == 27) {
                t.hideModal();
             }
        });
        $('body').append(t.modal);
        t.modal.modal('show');
        //$(timerParticipantsSelect).select2();
    };

    hideModal() {
        let t = this;
        if (t.modal != null) {
            t.modal.modal('hide');
            //end card 584
            setTimeout(() => {
                t.modal.remove();
                t.modal = null;
            }, 500);
        }
    };
    getKinoParticipantIds() {
        let pids=Object.keys(Video.videos);
        pids.push(room.myUserId());
        return pids;
    };

    durationToSeconds(m,s){
        //let hourToSeconds=parseInt(h)*3600;
        let minuteToSeconds=parseInt(m)*60;
        return minuteToSeconds+parseInt(s);
    };
    startNewTimer(preDefinedDuration=false, start=false, fromComponent=false){
        let t = this;
        // if(t.activeTimers && !t.isStopped){
        //     t.errorMessage.addClass('visible').html("Another timer is currently ongoing");
        //     return
        // }
        if(t.errorMessage){
            t.errorMessage.html('').removeClass('visible');
        }
        let duration=preDefinedDuration;
        // let inputHour=parseInt(t.hourInput.val());
        if(!duration && !fromComponent){
            let inputMinute=parseInt(t.minuteInput.val());
            let secondInput=parseInt(t.secondInput.val());
            if(isNaN(inputMinute) || isNaN(secondInput)){
                t.errorMessage.html("Invalid duration input");
                return ;
            }
            duration=t.durationToSeconds(inputMinute,secondInput);
        }
        t.showNotificationCountDownAtDefault = t.durationToSeconds(t.notificationTimeInputMinutes.val(), t.notificationTimeInputSeconds.val())
        // console.log(t.showNotificationCountDownAtDefault)
        // t.myTimer = duration;
        // t.showNotificationCountDownAt = t.notificationTimeInput.val();
        if(duration < 10 && t.showCountDownDefault || duration < 10){
            t.errorMessage.addClass('visible').html("Minimum duration is 10 seconds");
            return
        }else{
            if(t.errorMessage){
                t.errorMessage.html('').removeClass('visible');
            }
        }
        if(t.showNotificationCountDownAtDefault > duration  && t.showCountDownDefault){
            t.errorMessage.addClass('visible').html("Countdown cannot be set higher than the timer");
            return
        }
        if(t.showNotificationCountDownAtDefault == null  && t.showCountDownDefault){
            t.errorMessage.addClass('visible').html("Countdown notification is required");
            return;
        }
        // console.error('show notification at: ',t.showNotificationCountDownAt,' duration: ', duration)
        if(preDefinedDuration===false){
            t.setNewPreferences({
                minutes:parseInt(t.minuteInput.val()),
                seconds:parseInt(t.secondInput.val()),
                showNotification:t.showCountDownDefault,
                showNotificationAt:t.showNotificationCountDownAtDefault,
                playNotificationSound:t.playCountDownSoundDefault
            });
        }
        t.showCountDown = t.showCountDownDefault,
        t.showNotificationCountDownAt = t.showNotificationCountDownAtDefault,
        t.playCountDownSound = t.playCountDownSoundDefault,
        t.lastTimerSeconds = duration;
        //timerComponent.updateTimerInputs();
        // let timeNow=moment();
        // t.activeTimersID = new Date().getTime();
        // let options={
        //     hostStartDate:timeNow,
        //     seconds:duration,
        //     // timer_title:sanitizedTitle,
        //     id: t.activeTimersID,
        //     from_id:room.myUserId(),
        //     from_name: MY_NAME,
        //     seconds_left: null,
        //     showCountDown: t.showCountDownDefault,
        //     startCountDownAt : t.showNotificationCountDownAtDefault,
        //     playCountDownSound: t.playCountDownSoundDefault,
        // };
        if(t.modal){
            t.hideModal();
        }
        if(t.isPaused && t.isStopped){
            t.appendTimerWidget(options.id,'Timer');
        }
        // if(start){
        //     t.sendTimerMessage(options);
        //     t.startTimer(options,"You");
        // }
        //start my timer

    };

    // resetTimerInput(){
    //     // t.hourInput.val('00');
    //     t.minuteInput.val('00');
    //     t.secondInput.val(10);
    //     t.errorMessage.html('');
    // }
    sendTimerMessage(data){
        try {
            if(Object.keys(Video.videos).length >= 1){
                room.broadcastEndpointMessage({
                    timer_message: "start_timer",
                    data: data
                });
            }
            // room.broadcastEndpointMessage({
            //     timer_message: "resume_timer",
            //     data: data
            // });
        } catch (error) { console.error("[Kino Error] [KinoTimer]", error); }
    };
    timerMessageHandle(message, user){
        let t = this;
        console.log("______________________________new timer message",message)
        switch (message.timer_message) {
            case "start_timer":
                t.startTimer(message.data);
                break;
            case "pause_timer":
                t.pauseTimerHandler(message.data, user.getDisplayName());
                break;
            case "resume_timer":
                t.resumeTimerHandler(message.data,user.getDisplayName());
                break;
            case "stop_timer":
                t.stopTimerHandler(message.data,user.getDisplayName());
                break;
            case "timer_ended":
                t.timerEndedHandler(message.data);
                break;
            case "start_timer_on_join":
                t.handleStartTimerOnJoin(message.data);
                break;
            case "timer_closed":
                t.closeTimerHandler(message.data,user.getDisplayName());
                break;

            default:
                break;
        }
    };

    startTimer(options){
        console.error(options)
        let t=this;
        t.isPaused = false;
        t.isStopped = false;
        t.notificationPlayed = false;
        // console.log(options);
        if(t.activeTimers && t.activeTimers.id == options.id){return}
        if(t.modal && !t.modal.hasClass('minimized-modal')){
            t.hideModal();
        }
        // console.error('TIMER************',options.startCountDownAt);
        t.lastTimerSeconds = options.seconds;
        t.showCountDown = options.showCountDown;
        t.showNotificationCountDownAt = options.startCountDownAt;
        t.playCountDownSound = options.playCountDownSound;
        t.recurring=options.recurring ? options.recurring : false;
        t.current_round = options.current_round ? options.current_round : 0;
        t.total_rounds = options.total_rounds ? options.total_rounds : 0;
        let time = t.secondsToTime(options.seconds);
        let p=kinoParticipants.get(options.from_id);
        let name = options.from_id == room.myUserId() ? 'You' : p ? p.getName() : options.from_name;
        // console.log('m :',time.m, 's:',time.s )
        // let message=`${name} started a countdown of ${time.m != '00' ? `${time.m} : ${time.s} minutes` : `${time.s} seconds`}`;
        let message = "Countdown started";
        //Make sure to remove any existing timer notification
        if(t.activeTimers.from_id || $('#timer_ending-null')){
            if(t.activeTimers.from_id){
                $(`#timer_ending-${t.activeTimers.from_id}`).remove();
            }
            if($('#timer_ending-null')){
                $('#timer_ending-null').remove();
            }
        }
        // options.is_stopped || Video.showNotification(null,message,'timer',false)
        if(options.seconds == options.startCountDownAt && options.showCountDown){
            Video.showNotification(null, {showNotifAt: options.startCountDownAt, playSound: options.playCountDownSound}, 'timer_ending', options.from_id)
        }
        // console.log(`Starting new timer with options`,options);
        t.activeTimers=new Timer({
            seconds:options.seconds,
            hostStartDate:options.hostStartDate,
            from_id:options.from_id,
            from_name: options.from_name,
            id:options.id,
            showCount: options.showCountDown,
            showCountAt: options.startCountDownAt,
            playSound: options.playCountDownSound,
            serverStartTime: options.serverStartTime,
            serverEndTime: options.serverEndTime
        },(secondsLeft,timerId)=>{
            if(timerId!=t.activeTimers.id){return}
            if(secondsLeft == options.startCountDownAt && options.showCountDown && !t.isPaused){
                Video.showNotification(null,{showNotifAt: options.startCountDownAt,playSound: options.playCountDownSound},'timer_ending', options.from_id)
            }
            // console.log("timer update seconds left "+ secondsLeft);
            if(secondsLeft <= 10 && !t.notificationPlayed){
                t.notificationPlayed = true;
                if($('#timer_ending-null') || $(`#timer_ending-${options.from_id}`)){
                    if($('#timer_ending-null')){
                        $('#timer_ending-null').remove();
                    }
                    if($(`#timer_ending-${options.from_id}`)){
                        $(`#timer_ending-${options.from_id}`).remove();
                    }
                }
                if(options.showCountDown && options.startCountDownAt > 10){
                    // Video.showNotification(null,null,'timer_ending',null)
                    Video.showNotification(null,{showNotifAt: 10 ,playSound: options.playCountDownSound},'timer_ending', null)
                }
            }
            t.updateSecondsLeft(options.id,secondsLeft);
            if(secondsLeft === 0 ){
                // console.log("timerID update:",timerId);
                // t.timerEnded();
                // t.timerEndedHandler();
            }
        },
        (timerId,fromUser)=>{
            if(!t.isStopped){
                // console.log("timerID stop:",timerId);
                if(timerId!=t.activeTimers.id){return}

                t.removeRoundsContainer();
                if(!t.recurring){
                    t.timerEndedHandler();
                }
                if(t.errorMessage){
                    t.errorMessage.html('').removeClass('visible');
                }
            }
            if(!fromUser && t.recurring){
                t.onStop();
            }else{
                Video.splitConversations.onTimerStoppedFromUser(timerId);
            }
        });
        t.appendTimerWidget(options.id,'Timer');
        options.is_stopped || t.kinoToolTip.showTooltip({message: message, container: t.timerWidgetContainer, options: {left: '0%',bottom: '160%'}})
        if(name == "You"){
            options.is_stopped || permissions.hasKinoTimer() ? Video.showNotification(null,`Countdown started`,'timer',false) : '';
        }
        else {
            options.is_stopped || permissions.hasKinoTimer() ? Video.showNotification(null,`${name} started the countdown`,'timer',false) : '';
        }
        if(options && options.recurring){
            message=`Shuffling countdown has begun`;
            t.addRoundsContainer(options.current_round, options.total_rounds);
        }
        if(!options.is_stopped){
            if(options.is_paused){
                t.activeTimers.secondsLeft=options.seconds_left;
                t.activeTimers.isPaused=true;
            }
            t.activeTimers.start(options.seconds_left ? options.seconds_left : 0);
        }
        clearTimeout(t.stopTimeout);
    };

    onStop(){
        Video.splitConversations.onTimerEnded();
    };

    pauseResumeRestart(){
        var t = this;

        // console.log('Is paused? ',t.isPaused, ' Is stopped ? ',t.isStopped)
        if(!t.isPaused && t.isStopped || t.isPaused && t.isStopped){
            if(t.lastTimerSeconds){
                // t.startNewTimer(t.lastTimerSeconds, true);
                t.playLastTimer(t.lastTimerSeconds);
            }
        }else if (!t.isPaused){
            t.pauseTimer();
        }else{
            t.resumeTimer();
        }
    }

    //received when someone pauses timer
    pauseTimerHandler(message,name){
        let t = this;
        let secLeft = 0;
        // substring(0, 15) + "..."
        let pauseMessage = "Countdown paused";
        t.isPaused = true;
        if(t.activeTimers && t.activeTimers.id){
            secLeft = t.activeTimers.pause();
            if(t.activeTimers.from_id){
                // console.log("Existing notification",$(`#timer_ending-${t.activeTimers.from_id}`));
                $(`#timer_ending-${t.activeTimers.from_id}`).remove();
            }
        }
        if(t.playPauseButton) { t.playPauseButton.html(t.resumeIcon).attr({title: 'Resume', 'data-original-title': 'Resume'})};
        let time = t.secondsToTime(secLeft);
        Video.showNotification(null,null,'timer_ending',null)
        // Video.showNotification(null,`${name} paused the countdown at ${time.m != '00' ? `${time.m} : ${time.s} minutes` : `${time.s} seconds`}`,'timer',false)
        // Video.showNotification(null,pauseMessage,'timer',false)
        if(name == "You"){
            permissions.hasKinoTimer() ? Video.showNotification(null,`Countdown paused`,'timer',false) : '';
        }
        else {
            permissions.hasKinoTimer() ? Video.showNotification(null,`${name} paused the countdown`,'timer',false) : '';
        }
        t.kinoToolTip.showTooltip({message: pauseMessage, container: t.timerWidgetContainer, options: {left: '0%', bottom: '160%'}})
    }
    //user clicks the pause button
    pauseTimer(){
        let t = this;
        let currentTimer = t.activeTimers;
        if(Object.keys(Video.videos).length >= 1){
            room.broadcastEndpointMessage({
                timer_message: "pause_timer",
                data: {
                    seconds: currentTimer.timerSeconds,
                    hostStartDate: currentTimer.hostStartDate,
                    from_id: room.myUserId(),
                    from_name: MY_NAME,
                    id: currentTimer.id,
                    seconds_left : currentTimer.secondsLeft,
                    showCount: t.showCountDown,
                    showCountAt: t.showNotificationCountDownAt,
                    playSound: t.playCountDownSound
                }
            });
        }
        t.pauseTimerHandler(null, "You");
    }

    resumeTimerHandler(message, name){
        let t = this;
        let secLeft = 0;
        let resumeMessage = "Countdown resumed";
        t.isPaused = false;
        if(t.activeTimers && t.activeTimers.id){
            if(message){
                t.activeTimers.serverStartTime=message.serverStartTime;
                t.activeTimers.serverEndTime=message.serverEndTime;
            }
            t.activeTimers.resume();
            secLeft = t.activeTimers.secondsLeft;
        }
        if(t.playPauseButton) {t.playPauseButton.html(t.pauseIcon).attr({title: 'Pause', 'data-original-title': 'Pause'})};
        let time = t.secondsToTime(secLeft);
        // console.error(time.m);
        // Video.showNotification(null,`${name} resumed the countdown at ${time.m != '00' ? `${time.m} : ${time.s} minutes` : `${time.s} seconds`}`,'timer',false)
        // Video.showNotification(null,resumeMessage,'timer',false)
        if(name == "You"){
            permissions.hasKinoTimer() ? Video.showNotification(null,`Countdown resumed`,'timer',false) : '';
        }
        else {
            permissions.hasKinoTimer() ? Video.showNotification(null,`${name} resumed the countdown`,'timer',false) : '';
        }

        t.kinoToolTip.showTooltip({message: resumeMessage, container: t.timerWidgetContainer, options: {left: '0%',bottom: '160%'}})
    }

    async resumeTimer(options){
        // console.log('resume options: ', options)
        let t = this;
        let currentTimer = t.activeTimers;
        //get server time here
        let server=await t.getServerTime(currentTimer.secondsLeft,1);
        t.activeTimers.serverStartTime=server.start;
        t.activeTimers.serverEndTime=server.end;

        if(Object.keys(Video.videos).length >= 1){
            room.broadcastEndpointMessage({
                timer_message: "resume_timer",
                data: {
                    seconds: currentTimer.timerSeconds,
                    hostStartDate: currentTimer.hostStartDate,
                    from_id: room.myUserId(),
                    from_name: MY_NAME,
                    id: currentTimer.id,
                    seconds_left : currentTimer.secondsLeft,
                    showCount: t.showCountDown,
                    showCountAt: t.showNotificationCountDownAt,
                    playSound: t.playCountDownSound,
                    serverStartTime:t.activeTimers.serverStartTime,
                    serverEndTime:t.activeTimers.serverEndTime
                }
            });
        }
        t.resumeTimerHandler(null, "You");
    }

    stopTimerHandler(message, name){
        let t = this;
        let stopMessage = "Countdown stopped";
        let lastTimerSec = message.lastTimerSeconds;
        // console.error(lastTimerSec)
        t.isPaused = true;
        t.isStopped = true;
        if(t.activeTimers && t.activeTimers.id){
            if(t.activeTimers.from_id){
                // console.log("Existing notification",$(`#timer_ending-${t.activeTimers.from_id}`));
                $(`#timer_ending-${t.activeTimers.from_id}`).remove();
            }
            t.activeTimers.stop(message.fromUser);
            t.activeTimers = {};
            // t = Object.values(t.activeTimers)[0].secondsLeft;
        }
        t.removeRoundsContainer();
        if(t.playPauseButton){t.playPauseButton.html(t.resumeIcon).attr({title: 'Start', 'data-original-title': 'Start'})};
        if(t.stopButton){$(t.stopButton).attr('disabled', true).addClass('disabled cursor-default');}

        t.resetTimerWidget(t.lastTimerSeconds);
        if(!message || !message.silent){
            Video.showNotification(null,null,'timer_ending',null)
            // Video.showNotification(null,stopMessage,'timer',false)
            if(name == "You"){
                permissions.hasKinoTimer() ? Video.showNotification(null,`Countdown stopped`,'timer',false) : '';
            }
            else {
                permissions.hasKinoTimer() ? Video.showNotification(null,`${name} stopped the countdown`,'timer',false) : '';
            }

            t.kinoToolTip.showTooltip({message: stopMessage, container: t.timerWidgetContainer, options: {left: '0%',bottom: '160%'}})
        }
        t.removeTimerContainer();

    }

    stopTimer(silent=false){
        let t = this;
        if(t.isStopped) return;
        // console.log('called stop timer');
        if(Object.keys(Video.videos).length >= 1){
            try {
                room.broadcastEndpointMessage({
                    timer_message: "stop_timer",
                    data: {silent:silent,fromUser:true,lastTimerSeconds:t.lastTimerSeconds}
                });
            } catch (error) { console.error("[Kino Error] [KinoTimer]", error); }

        }
        t.stopTimerHandler({silent:silent,fromUser:true}, "You");
    }

    timerEndedHandler(message){
        let t = this;
        // console.log(`timerEndedHandler `,t);
        t.isPaused = true;
        t.isStopped = true;
        if(t.activeTimers && t.activeTimers.id){
            t.activeTimers.stop();
            t.activeTimers = {};
            //  Video.showNotification(null,{showNotifAt: t.showNotificationCountDownAt ,playSound: t.playCountDownSound},'timer_ending',null)
            Video.showNotification(null,null,'timer_ending',null)
            if(t.playPauseButton){t.playPauseButton.html(t.resumeIcon).attr({title: 'Start', 'data-original-title': 'Start'})};
            $(t.stopButton).attr('disabled', true).addClass('disabled cursor-default');
            t.kinoToolTip.showTooltip({message: 'Countdown ended', container: t.timerWidgetContainer, options: {left: '0%',bottom: '160%'}})
            t.removeTimerContainer();

        }
        t.resetTimerWidget(t.lastTimerSeconds);
    }

    timerEnded(){
        let t = this;
        if(t.isStopped) return;
        if(Object.keys(Video.videos).length >= 1){
            try {
                room.broadcastEndpointMessage({
                    timer_message: "timer_ended",
                    data: {}
                });
            } catch (error) { console.error("[Kino Error] [KinoTimer]", error); }
        }
        t.timerEndedHandler();
    }

    closeTimer(){
        let t = this;
        if(!t.isStopped) return;
        if(Object.keys(Video.videos).length >= 1){
            try {
                room.broadcastEndpointMessage({
                    timer_message: "timer_closed",
                    data: {}
                });
            } catch (error) { console.error("[Kino Error] [KinoTimer]", error); }
        }
        t.closeTimerHandler();
    }

    closeTimerHandler(message, name){
        let t = this;
        if(!t.isStopped){
            t.stopTimerHandler(message, name)
        }
        t.closeAndStopTimer();
    }

    resetTimerWidget(t){
        let time = this.secondsToTime(t);
        $('#widget-minutes-span').html(time.m).val(time.m)
        $('#widget-seconds-span').html(time.s).val(time.s)
    }

    closeAndStopTimer(skip=false){
        let t = this;
        $(".timer-timers-container").html('');
        $(".timer-timers-container").addClass('d-none');
        if(skip){
            if($('.notificationContent')){
                $('.notificationContent').remove();
            }
        }
        if(!skip){
            t.stopTimer();
        }
    }

    removeTimerContainer(){
        let t = this;
        clearTimeout(t.stopTimeout);
        t.stopTimeout = setTimeout(() => {
            if(!permissions.hasKinoTimer()) {
                $(".timer-timers-container").html('').addClass('d-none')
            }
        }, 3000);

    }

    getParticipantName(id){
        return id==room.myUserId() ? "You" : room.getParticipantById(id).getDisplayName();
    }

    handleStartTimerOnJoin(data, user){
        let t = this;
        // console.error('USER ON JOIN STARTED')
        // console.log('User data on join: ', data);
        if(t.activeTimers && t.activeTimers.id == data.id){return};
        t.startTimer(data);
        t.isPaused = data.is_paused;
        t.isStopped = data.is_stopped;
        t.showCountDown = data.showCount;
        t.showNotificationCountDownAt = data.showCountAt;
        t.playCountDownSound = data.playSound;

        if(data.is_paused){
            if(t.playPauseButton){
                t.playPauseButton.html(t.resumeIcon).attr({title: 'Resume', 'data-original-title': 'Resume'});
            }
        }
        if(data.is_stopped) {
            t.resetTimerWidget(data.seconds)
            if(t.playPauseButton){
                t.playPauseButton.html(t.resumeIcon).attr({title: 'Start', 'data-original-title': 'Start'});
            }
            return;
        }
        if(data.seconds_left){t.resetTimerWidget(data.seconds_left)}
    };

    //function to be called upon user joining
    userConnected(user){
        let t = this;
        // console.log(user);
        if(!t.activeTimers || !t.activeTimers.id){
            return;
        }
        let currentTimer = t.activeTimers;
        // console.log('kino timer user: ',currentTimer);
        room.sendEndpointMessage(user.getId(), {
            timer_message: 'start_timer_on_join',
            data: {
                seconds: currentTimer.timerSeconds,
                hostStartDate: currentTimer.hostStartDate,
                from_id: currentTimer.from_id,
                from_name: currentTimer.from_name,
                id: currentTimer.id,
                seconds_left : t.Paused ? currentTimer.secondsLeft : currentTimer.secondsLeft - 1,
                is_stopped: t.isStopped,
                is_paused: t.isPaused,
                showCount: t.showCountDown,
                showCountAt: t.showNotificationCountDownAt,
                playSound: t.playCountDownSound,
                recurring:t.recurring,
                serverStartTime:t.activeTimers.serverStartTime,
                serverEndTime:t.activeTimers.serverEndTime,
                current_round: t.current_round,
                total_rounds: t.total_rounds
            }
        })
    }

    onPreferencesLoaded(){
        if(this.preferences['minutes']!==undefined){
            this.defaultStateMinutes=this.preferences.minutes;
            if(this.defaultStateMinutes < 10){
                this.defaultStateMinutes='0'+this.defaultStateMinutes;
            }
        }
        if(this.preferences['seconds']!==undefined){
            this.defaultStateSeconds=this.preferences.seconds;
            if(this.defaultStateSeconds < 10){
                this.defaultStateSeconds='0'+this.defaultStateSeconds;
            }
        }
        if(this.preferences['showNotification']!==undefined){
            this.showCountDownDefault=this.preferences.showNotification;
        }
        if(this.preferences['playNotificationSound']!==undefined){
            this.playCountDownSoundDefault=this.preferences.playNotificationSound;
        }
        if(this.preferences['showNotificationAt']!==undefined){
            this.showNotificationCountDownAtDefault=this.preferences.showNotificationAt;
        }
    };

    setNewPreferences(preferences){
        this.preferences=preferences;
        userPreferences.storeNewPreferences('kino_timer',preferences);
    };

    async playLastTimer(seconds){
        let t = this;
        let timeNow=moment();
        let timerID=new Date().getTime();
        t.activeTimersID = timerID;
        t.myTimer=seconds;
        let server=await t.getServerTime(seconds,1);
        let options={
            hostStartDate:timeNow,
            seconds:seconds,
            id: t.activeTimersID,
            from_id:room.myUserId(),
            from_name:MY_NAME,
            seconds_left: null,
            showCountDown: t.showCountDown,
            startCountDownAt : t.showNotificationCountDownAt,
            playCountDownSound: t.playCountDownSound,
            serverStartTime: server.start,
            serverEndTime: server.end
        };
        t.sendTimerMessage(options);
        t.startTimer(options,"You");
        // console.error("Start Exisiting timer",options);
    };

    async getServerTime(duration,offset=0){
        let serverTime=await socket.getServerTime();
        let returnTime={start:null,end:null};
        if(serverTime){
            returnTime.start=moment.utc(serverTime).format("YYYY-MM-DD HH:mm:ss");
            returnTime.end=moment.utc(serverTime).add(duration+offset,'seconds').format("YYYY-MM-DD HH:mm:ss");
            // console.log(`Server start ${this.serverStartTime} server end ${this.serverEndTime}`);
        }
        return returnTime;
    };
};
